import { cardListStyles } from "@insite/content-library/Components/CardList";
import { css } from "styled-components";

cardListStyles.gridContainer = {
    gap: 0,
    css: css`
        width: 100%;
    `,
};
